import { $, $$ } from '@3pc/dom';
import Autosuggest from './helpers/Autosuggest.js';

const searchForm = $$('.search-teaser-form');

searchForm.forEach(form => {
  const input = $('.search-teaser-input', form);

  if (!input) {
    // eslint-disable-next-line no-throw-literal
    throw '`.search-teaser-form` present, but no `.search-teaser-input` found!';
  }

  const submitForm = () => {
    const baseUrl = window.location.origin;
    const searchUrl = form.getAttribute('action');
    const inputValue = input.value;
    const searchURL =
      baseUrl +
      searchUrl +
      (inputValue ? '#tx_solr%5Bq%5D=' : '') +
      encodeURIComponent(inputValue);
    window.location.href = searchURL;
  };
  const submitButton = $('.search-teaser-button', form);

  if (!submitButton) {
    // eslint-disable-next-line no-throw-literal
    throw '`.search-teaser-form` present, but no `.search-teaser-button` found!';
  }

  submitButton.addEventListener('click', event => {
    event.preventDefault();
    submitForm();
  });

  submitButton.addEventListener('keyup', event => {
    if (event.keyCode === 13) {
      event.preventDefault();
      submitForm();
    }
  });

  setTimeout(() => {
    if (form && input) {
      const autoSuggestObj = new Autosuggest({
        // input which triggers solr
        input,
        // form element which contains the input
        form,
        // the suggest endpoint
        serviceUrl: form.getAttribute('data-suggestUrl'),
        // [optional] min length of text until we fire the ajax-request (0 is default)
        textMinLength: 2,
        // [optional] set true, if you want to enable typeahead
        typeahead: false,
        // [optional] prevent AutoSuggest from submitting the form (e.g. if you want to trigger ajax instead) (default is false)
        preventSubmit: true,
        // [optional] allow empty submit even if input is empty (default is false)
        allowEmptySubmit: true,
        // [optional] submit form if user clicks on a suggestion button (default is false)
        submitOnSuggestionClick: false,
      });
      autoSuggestObj.init();
    }
  }, 0);
});
